import React from 'react';
import { FileTextIcon, ZapIcon, SmartphoneIcon, FlagIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
import { PRODUCT_FACTS } from './salesData';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1024;
const HERO_IMG_HEIGHT = 1024;
const badges = [{
  icon: FileTextIcon,
  label: 'Sistema completo digital'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: FlagIcon,
  label: 'Hecho para Argentina'
}, {
  icon: SmartphoneIcon,
  label: 'Instagram → Alumnos'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-sand" data-id="element-117" data-mp="nczt16jsw3vm">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-stone/50 blur-3xl" aria-hidden data-id="element-118" data-mp="nekm0rqgverd" />
      <div className="absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-sage-soft/50 blur-3xl" aria-hidden data-id="element-119" data-mp="382fedm0930dv" />

      <div className="relative mx-auto max-w-3xl px-6 py-6 text-center sm:px-5 sm:py-12" data-id="element-120" data-mp="3j8sg632wlnqw">
        <div className="animate-hero-copy" data-id="element-121" data-mp="3o7c1c19oavi7">
          <p className="font-sans text-[0.66rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-122" data-mp="3o6aru18b2h2l">
            Wellness Digital Pro™
          </p>
          <h1 className="mx-auto mt-2.5 max-w-[22ch] font-display text-[1.95rem] font-semibold leading-[1.12] text-charcoal sm:max-w-[26ch] sm:text-[2.9rem]" data-id="element-123" data-mp="3e9625rf943h1">
            No necesitás publicar más.
            <span className="mt-1 block text-gold-deep" data-id="element-124" data-mp="358hncui19z33">
              Necesitás un sistema para que lo que publicás convierta.
            </span>
          </h1>
        </div>

        <img src={HERO_IMG} alt="MegaPack Wellness Digital Pro: seis tomos impresos sobre superficie de piedra junto a una notebook" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 54vw, 400px" style={{
        aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
      }} className="animate-hero-media mx-auto mt-3.5 block h-auto w-[54%] max-w-[278px] rounded-2xl object-contain shadow-[0_26px_54px_-32px_rgba(28,27,25,0.4)] sm:mt-6 sm:w-[76%] sm:max-w-[400px]" data-id="element-125" data-mp="2qi0kr7tnx34m" />

        <p className="mx-auto mt-2.5 max-w-xl font-sans text-[0.85rem] leading-relaxed text-charcoal/70 sm:mt-5 sm:text-sm" data-id="element-126" data-mp="dd5ews2mzp5p">
          El sistema práctico para profes de Yoga, Pilates, Meditación, coaches y profesionales del
          bienestar que quieren transformar Instagram en una fuente de nuevas consultas y clientes.
        </p>

        <p className="mt-3.5 font-sans text-base font-semibold text-charcoal sm:mt-4 sm:text-lg" data-id="element-127" data-mp="111omt6hrxzx9">
          El sistema completo + 5 bonos de implementación
        </p>

        <PriceBlock className="mt-2" data-id="element-128" data-mp="3lsp3vew9yley" />

        <div className="mt-3.5 flex justify-center sm:mt-4" data-id="element-129" data-mp="3ltqczdtqcxu1">
          <CTAButton className="w-full max-w-[24rem] px-5" data-id="element-130" data-mp="3hqu1s86is404" />
        </div>

        <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-131" data-mp="3htpzbveggqo1">
          Acceso inmediato. Empezá a aplicarlo hoy.
        </p>
        <p className="mt-1 font-sans text-[0.7rem] text-charcoal/50" data-id="element-132" data-mp="21a4t5ua36g5g">
          Garantía 7 días · Pago seguro
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2" data-id="element-133" data-mp="2697ouo46fa0r">
          {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-ivory px-3 py-1.5 font-sans text-[0.68rem] font-medium text-charcoal/80" data-id="element-134" data-mp="2b20q320fs083">
              <b.icon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-135" data-mp="2p0h7pnzu7b50" />
              {b.label}
            </span>)}
        </div>
      </div>

      <div className="relative border-t border-stone bg-ivory/70" data-id="element-136" data-mp="2tyafumkpaf7x">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-5 gap-y-1.5 px-5 py-3 text-center font-sans text-[0.74rem] text-charcoal/70" data-id="element-137" data-mp="umzf3mkkro34">
          {PRODUCT_FACTS.map((fact, i) => <React.Fragment key={fact} data-id="element-138" data-mp="4acmjdl07r7y" data-mpi={i}>
              {i > 0 && <span className="hidden h-3.5 w-px bg-stone-deep sm:block" aria-hidden data-id="element-139" data-mp="4d78j9jo1k3h" />}
              <span data-id="element-140" data-mp="3vjrr04vnnjow">{fact}</span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}